window.merchantos.auditLog = {
  logPrint: (type, ids) => {
    let entity;

    switch (type) {
      case 'customer':
        entity = 'customers';
        break;
      case 'employee':
        entity = 'employees';
        break;
      default:
        entity = '';
    }
    if (entity) {
      $.ajax({
        url: `/admin/${entity}/logprinted`,
        type: 'POST',
        dataType: 'json',
        data: JSON.stringify({
          ids,
        }),
      });
    }
  },
};
